/* eslint-disable import/prefer-default-export */
import { baseUrl } from "./baseUrl";

export const recreateFinancialDocuments = () =>
  [`${baseUrl}`, "processes-api", "processes/recreate-financial-documents"].join("/");
